const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#83CF8F"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "163.041,326.344 188.023,295.051 193.939,299.784 169.089,331.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "342.911,331.078 317.929,299.784 323.846,295.051 348.828,326.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "252.187,377.229 252.187,317.009 259.813,317.009 259.813,377.229  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 192.493,
    r: 132.01
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECF0F1"
    },
    cx: 256,
    cy: 192.493,
    r: 124.516
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0BA7D"
    },
    points: "240.09,193.676 246.402,193.676 265.467,193.676 271.778,193.676 274.408,220.368  279.01,224.049 288.608,230.098 256,307.147 223.392,230.098 232.99,224.049 237.592,220.368 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF0F1"
    },
    points: "229.703,226.022 203.406,234.305 256,307.147 300.705,231.938 282.165,226.022  265.861,237.592 246.139,237.592 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF5B62"
    },
    points: "250.083,236.54 252.318,242.063 247.322,305.175 256,311.749 264.546,305.175  259.55,242.063 261.785,236.54 256,236.277 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7F9E"
    },
    d: "M230.098,225.89l-46.414,14.858c0,0-6.048,3.156-7.889,12.622c-1.709,9.072-2.63,18.408-4.076,31.03 c22.221,20.38,51.673,32.74,84.15,32.74s61.929-12.36,84.15-32.74c-1.315-12.622-2.235-21.826-4.076-31.03 c-1.841-9.467-7.889-12.622-7.889-12.622l-46.151-14.595l-26.165,76.787l-25.902-76.918L230.098,225.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8597B1"
    },
    d: "M230.098,225.89l-9.993,3.156l-1.972,25.376c0,0,0.526,2.104,2.104,1.841l9.072,3.419 c0,0,0.657,0.657,0,1.315l-7.758,5.259l26.691,50.358c2.498,0.132,4.996,0.263,7.626,0.263c2.498,0,5.128-0.131,7.626-0.263 l26.691-50.358l-7.758-5.259c-0.526-0.789,0-1.315,0-1.315l9.072-3.419c1.578,0.131,2.104-1.841,2.104-1.841l-1.972-25.376 l-9.73-3.024l-26.165,76.787l-25.902-76.918H230.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M219.053,139.373c0,2.498-0.92,4.865-0.789,7.232c-8.546-1.578-4.339,23.667,0.394,27.086 c0.394,0.263,1.315-0.394,2.104-0.789c1.709,9.335,15.91,34.054,24.982,44.442c2.498,2.893,17.882,2.893,20.38,0.131 c9.204-10.256,23.536-35.238,25.113-44.573c0.789,0.526,1.709,1.183,2.104,0.789c4.865-3.419,8.941-28.664,0.394-27.086 c0.131-2.367-0.789-4.865-0.789-7.232c-0.526-19.591-18.276-29.321-36.947-29.452C237.329,110.052,219.579,119.782,219.053,139.373z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#596366"
    },
    d: "M282.954,114.26c2.63-0.263,12.36,2.63,13.543,12.885s0.657,19.723,0.657,19.723 s-5.654,1.446-6.443,7.232c-0.657,5.785-0.263,5.785-0.263,5.785l-2.104-0.526l-1.446-9.993c-8.415-5.259,0.132-13.148-8.415-14.989 c-22.878,16.304-43.127,13.543-52.199,5.917c0,0,2.104,8.021,0.526,10.913c-1.578,2.893-0.657,7.363-0.657,7.363l-2.104-0.131 c0,0,0.394-11.834-4.339-11.834C201.697,116.89,258.63,80.074,282.954,114.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.329,216.555c0.657,0-7.758,9.598-7.758,9.598l7.232,24.588L256,236.409 c-10.519-5.128-16.83-11.965-18.671-19.723V216.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.671,216.555c-0.657,0,7.758,9.598,7.758,9.598l-7.232,24.588L256,236.409 c10.519-5.128,16.83-11.965,18.671-19.723V216.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.083,319.77c26.823,0,48.649,21.695,48.649,48.518c0,26.823-21.695,48.649-48.649,48.649 c-26.823,0-48.649-21.695-48.649-48.649C92.433,341.465,114.128,319.77,141.083,319.77z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7069"
    },
    d: "M141.083,323.846c24.588,0,44.442,19.854,44.442,44.442c0,24.588-19.854,44.442-44.442,44.442 s-44.442-19.854-44.442-44.442C96.641,343.7,116.495,323.846,141.083,323.846z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M124.516,385.249h1.183l6.837-3.682l1.052-4.339c-1.578-1.578-3.287-4.339-4.865-7.758 c-0.131,0-0.263,0-0.394,0c-1.841,0-3.55-1.972-3.945-4.339c-0.263-1.841,0.263-3.55,1.446-4.076 c-1.578-7.758-2.498-19.591,10.782-22.615c8.021-1.709,10.913,4.47,11.176,5.128c4.865-2.761,7.889,1.315,8.678,3.55 c1.446,3.945,0.92,11.176,0.263,14.332c0.789,0.789,1.183,2.104,0.92,3.682c-0.394,2.367-2.104,4.339-3.945,4.339 c-1.446,3.156-3.287,5.785-5.259,7.758l1.052,4.339h0.131l6.574,3.682h1.315c8.152,0,14.858,6.048,15.778,13.543 c-8.152,8.546-19.591,13.937-32.345,13.937s-24.193-5.391-32.345-13.937c0.789-7.626,7.626-13.543,15.778-13.543H124.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M370.917,319.77c26.823,0,48.649,21.695,48.649,48.518c0,26.823-21.695,48.649-48.649,48.649 c-26.823,0-48.649-21.695-48.649-48.649C322.268,341.465,343.963,319.77,370.917,319.77z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE356"
    },
    d: "M370.917,323.846c24.588,0,44.442,19.854,44.442,44.442c0,24.588-19.854,44.442-44.442,44.442 c-24.588,0-44.442-19.854-44.442-44.442C326.476,343.7,346.33,323.846,370.917,323.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7069"
    },
    d: "M354.35,385.249h1.183l6.837-3.682l1.052-4.339c-1.578-1.578-3.287-4.339-4.865-7.758 c-0.132,0-0.263,0-0.394,0c-1.841,0-3.55-1.972-3.945-4.339c-0.263-1.841,0.263-3.55,1.446-4.076 c-1.578-7.758-2.498-19.591,10.782-22.615c8.021-1.709,10.913,4.47,11.176,5.128c4.865-2.761,7.889,1.315,8.678,3.55 c1.446,3.945,0.92,11.176,0.263,14.332c0.789,0.789,1.183,2.104,0.92,3.682c-0.394,2.367-2.104,4.339-3.945,4.339 c-1.446,3.156-3.287,5.785-5.259,7.758l1.052,4.339h0.131l6.574,3.682h1.315c8.152,0,14.858,6.048,15.778,13.543 c-8.152,8.546-19.591,13.937-32.345,13.937c-12.754,0-24.193-5.391-32.345-13.937c0.789-7.626,7.626-13.543,15.778-13.543H354.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,377.229c26.823,0,48.649,21.695,48.649,48.518c0,26.823-21.695,48.649-48.649,48.649 c-26.823,0-48.649-21.695-48.649-48.649C207.351,398.923,229.046,377.229,256,377.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8597B1"
    },
    d: "M256,381.436c24.588,0,44.442,19.854,44.442,44.442c0,24.588-19.854,44.442-44.442,44.442 s-44.442-19.854-44.442-44.442C211.558,401.29,231.412,381.436,256,381.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M239.433,442.839h1.183l6.837-3.682l1.052-4.339c-1.578-1.578-3.287-4.339-4.865-7.758 c-0.131,0-0.263,0-0.394,0c-1.841,0-3.55-1.972-3.945-4.339c-0.263-1.841,0.263-3.55,1.446-4.076 c-1.578-7.758-2.498-19.591,10.782-22.615c8.021-1.709,10.913,4.47,11.176,5.128c4.865-2.761,7.889,1.315,8.678,3.55 c1.446,3.945,0.92,11.176,0.263,14.332c0.789,0.789,1.183,2.104,0.92,3.682c-0.394,2.367-2.104,4.339-3.945,4.339 c-1.446,3.156-3.287,5.785-5.259,7.758l1.052,4.339h0.132l6.574,3.682h1.315c8.152,0,14.858,6.048,15.778,13.543 c-8.152,8.546-19.591,13.937-32.345,13.937c-12.754,0-24.193-5.391-32.345-13.937c0.789-7.626,7.626-13.543,15.778-13.543H239.433z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/Categories.c234d6079ea7969b47410d62720ced6c.svg";
export { ForwardRef as ReactComponent };